export default "__VITE_ASSET__xk5CKGGi__"